import { render, staticRenderFns } from "./GlTabWarningDialog.vue?vue&type=template&id=52c035a4"
import script from "./GlTabWarningDialog.vue?vue&type=script&lang=js"
export * from "./GlTabWarningDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports